if (!customElements.get('advanced-grid-slider')) {
  customElements.define(
    'advanced-grid-slider',
    class AdvancedGridSlide extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.advanced-grid-slider__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.enableSlider = this.dataset.enableSlider === 'true';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }

        this.calculateItemsWidth();
        this.initVideoControls();
        this.playPase()
      }

      initSlider() {
        this.sliderOptions = {
          slidesPerView: 'auto',

          // 🔥 REQUIRED FOR CLICKABLE BUTTONS
          preventClicks: false,
          preventClicksPropagation: false,
          touchStartPreventDefault: false,

          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          loop: false,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          watchSlidesProgress: true,
        };

        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);

          this.sliderInstance = new window.FoxTheme.Carousel(
            this,
            this.sliderOptions,
            [FoxTheme.Swiper.Mousewheel]
          );

          this.sliderInstance.init();
        }

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            const index = Number(e.target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);

        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calculateItemsWidth() {
        Array.from(this.sliderWrapper.children).forEach((item) => {
          item.style.setProperty('--item-width', item.dataset.width);
          item.style.setProperty('--item-width-mobile', item.dataset.widthMobile);
        });
      }

      playPase(){
        const buttons = this.querySelectorAll('.video-play-pause-button');
        buttons.forEach((button)=>{
          button.addEventListener('click', ()=>{
            const videoBlock = button.closest('.block-video-item');
            const currentVideo = videoBlock.querySelector('video, iframe');
            const videoElement = videoBlock.querySelector('video-element');
            if(!videoElement.playing){
                if (currentVideo.tagName === 'VIDEO') {
                  videoElement.setAttribute('loaded', 'true');
                  videoElement.setAttribute('playing', 'true');
                  currentVideo.muted = false;
                  currentVideo.play();
                }

                if (currentVideo.tagName === 'IFRAME') {
                  videoElement.setAttribute('loaded', 'true');
                  videoElement.setAttribute('playing', 'true');
                  if (!this.originalSrc) {
                    this.originalSrc = currentVideo.src;
                  }

                  if (!currentVideo.src.includes('autoplay')) {
                    currentVideo.src =
                      this.originalSrc +
                      (this.originalSrc.includes('?') ? '&' : '?') +
                      'autoplay=1';
                  }
                }
              }else{
                videoElement.removeAttribute('playing');

                if (currentVideo.tagName === 'VIDEO') {
                  currentVideo.pause();
                  currentVideo.currentTime = 0;
                }

                if (currentVideo.tagName === 'IFRAME') {
                  currentVideo.src = video.originalSrc; // make sure this exists per element
                }
            }
          })
        })
      }
       initVideoControls(){
        document.addEventListener('video-played', (e) => {
          const videoId = e.detail.videoId;
          const videos = this.querySelectorAll('video-element');

          videos.forEach((video) => {
            const currentVideoId = video.dataset.videoId;

            if (currentVideoId !== videoId) {
              const currentVideo = video.querySelector('video, iframe');

              if (video.playing && currentVideo) {
                video.removeAttribute('loaded');
                video.removeAttribute('playing');

                if (currentVideo.tagName === 'VIDEO') {
                  currentVideo.pause();
                  currentVideo.currentTime = 0;
                }

                if (currentVideo.tagName === 'IFRAME') {
                  currentVideo.src = video.originalSrc; // make sure this exists per element
                }
              }else{
                video.removeAttribute('loaded');
                video.removeAttribute('playing');
              }
            }
          });
        });

       }
    }
  );
}

if (!customElements.get('advanced-grid-scroll-progress-bar')) {
  customElements.define(
    'advanced-grid-scroll-progress-bar',
    class AdvancedGridScrollProgressBar extends ScrollProgressBar {
      get totalWidth() {
        return [...this.target.children].reduce(
          (total, child) => total + child.offsetWidth,
          0
        );
      }
    }
  );
}
